import styled from 'styled-components';
import { COLOR, smartphone } from '../../../styles/variables';

export const RelatedContent = styled.div`
    margin: 2rem 0 5rem;
    width: 100%;
    box-sizing: border-box;
`;

export const StyledTeaser = styled.a`
    display: flex;
    flex-flow: row nowrap;
    font-weight: 400;
    color: ${COLOR.contentFont};
    text-decoration: none;
    margin-bottom: 1.5em;

    @media ${smartphone} {
        flex-flow: column nowrap;
    }
`;

export const Figure = styled.figure`
    display: flex;
    overflow: hidden;
    margin: 0;
    /* Safari hack */
    align-items: flex-start;
    max-width: 300px;

    @media ${smartphone} {
        max-width: 100%;
    }
`;

export const Image = styled.img<{ isZoomed: boolean }>`
    width: 100%;
    transform: scale(${({ isZoomed }) => (isZoomed ? 1.05 : 1)});
    transition: transform 0.25s ease-in-out;
`;

export const TextWrapper = styled.div`
    flex: 1 1 0%;
    margin-left: 1rem;
    line-height: 1.5;

    @media ${smartphone} {
        margin: 0.5rem 0 1rem;
    }
`;

export const Timestamp = styled.p`
    opacity: 0.55;
    font-size: 0.9rem;
    margin: 0.25rem 0;
`;

export const Title = styled.h4`
    font-weight: 700;
    font-size: 1.15rem;
    margin: 0 0 0.35rem;
`;

export const Text = styled.p`
    margin: 0;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    text-overflow: ellipsis;
    overflow: hidden;
`;
